import React from 'react'
import HeroSection from '../../components/career/HeroSection'
import JobSection from '../../components/career/JobSection'
import WorkSection from '../../components/career/WorkSection'
import { JoinTeamSection } from '../../components/career/JoinTeamSection'

const Career = () => {
  return (
    <div>
        <HeroSection/>
        <JobSection/>
        <WorkSection/>
        <JoinTeamSection/>
        
    </div>
  )
}

export default Career